import { ChangeDetectionStrategy, Component, Signal, inject } from '@angular/core';

import { BlockDirective, ElemDirective } from '@rt-tools/core';
import { ContactFormComponent, PageHeaderComponent } from '@stair-craft/common/components';
import { IStairConfig, LastStairConfigService } from '@stair-craft/common/util';

const BEM_BLOCK: string = 'sc-contacts-page';

@Component({
    selector: 'sc-contacts-page',
    templateUrl: './contacts-page.component.html',
    styleUrl: './contacts-page.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        // rt-tools
        BlockDirective,
        ElemDirective,

        // shared-ui-kit
        ContactFormComponent,
        PageHeaderComponent,
    ],
    host: {
        class: BEM_BLOCK,
    },
})
export default class ContactsPageComponent {
    readonly #lastConfigStore: LastStairConfigService = inject(LastStairConfigService);

    /**
     * Last stair configuration the user actually built in the constructor.
     * Passed to `<sc-contact-form>` so the studio sees the design when
     * a contact email comes in. `null` if the user has not visited the
     * constructor yet.
     */
    protected readonly lastStairConfig: Signal<IStairConfig | null> = this.#lastConfigStore.config;
}
